/** Maps Privacy Report data-scope ids to tenant license keys. */
export const REPORT_SOURCE_LICENSE = {
  consent: "consent",
  cookie: "consent",
  consent_variance: "consent",
  dsar: "dsar",
  pia: "dpia",
  tprm: "tprm",
  gap: "gap",
  ropa: "ropa",
  dspm: "dspm",
  breach: "breach",
  policy_store: "policy_store",
};

export const ROADMAP_LICENSE_KEYS = ["gap", "ropa", "dpia", "tprm"];

export const REPORT_FETCH_LICENSE = {
  overview: null,
  roadmap: ROADMAP_LICENSE_KEYS,
  consent: "consent",
  cookie: "consent",
  dsar: "dsar",
  pia: "dpia",
  tprm: "tprm",
  gap: "gap",
  ropa: "ropa",
  dspm: "dspm",
  breach: "breach",
  variance: "consent",
  policy: "policy_store",
  deptAssess: ROADMAP_LICENSE_KEYS,
};

export function tenantLicensedModules(user) {
  if (!Array.isArray(user?.modules)) return [];
  return user.modules
    .map((key) => String(key || "").trim().toLowerCase())
    .filter(Boolean);
}

function hasAnyLicense(licensed, keys) {
  return keys.some((key) => licensed.includes(key));
}

/** True when the tenant license covers this report source. Empty licenses grant nothing. */
export function hasReportLicense(licensed, sourceId) {
  const keys = Array.isArray(licensed) ? licensed : [];
  if (sourceId === "all") {
    return Object.values(REPORT_SOURCE_LICENSE).some((key) => keys.includes(key));
  }
  if (sourceId === "roadmap") {
    return hasAnyLicense(keys, ROADMAP_LICENSE_KEYS);
  }
  const moduleKey = REPORT_SOURCE_LICENSE[sourceId];
  return Boolean(moduleKey && keys.includes(moduleKey));
}

export function isReportFetchLicensed(licensed, taskKey) {
  const required = REPORT_FETCH_LICENSE[taskKey];
  if (required == null) return true;
  const keys = Array.isArray(licensed) ? licensed : [];
  if (Array.isArray(required)) return hasAnyLicense(keys, required);
  return keys.includes(required);
}

export function filterReportDataSources(sources, licensed) {
  const modules = sources.filter((source) => source.id !== "all" && hasReportLicense(licensed, source.id));
  if (!modules.length) return [];
  const all = sources.find((source) => source.id === "all");
  return all ? [all, ...modules] : modules;
}

export function isChartMetricLicensed(metricId, showModule) {
  if (!metricId || metricId === "auto" || metricId === "modules" || metricId === "compliance") {
    return true;
  }
  return !showModule || showModule(metricId);
}
